import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { ConsultationsService } from '../../../../core/services/consultation/consultations.service';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { PatientsService } from '../../../../core/services/patient/patients.service';
import { CommonModule, DatePipe } from '@angular/common';
import { ChatService } from '../../../../core/services/chat/chat.service';
import { CurrentUserService } from '../../../../core/services/user/current-user.service';
import { FullscreenService } from '../../../../core/services/fullscreen.service';
import { CreateChatModel } from '../../../../core/models/chat/create-chat-model';
import { StatusUtils } from '../../../../utils/status-utils';
import { environment } from '../../../../../environments/environment';
import { SignalRService } from '../../../../core/services/signalR/signalR';
import { CaseStatus } from '../../../../../enums/case-status.enum';
import { FullscreenOverlayComponent } from '../../../components/fullscreen-overlay/fullscreen-overlay.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../../core/services/language.service';
import { UserSessionModel } from '../../../../core/models/user/current-user.model';
import { AiImagesModel } from '../../../../core/models/consultation/ai-images.model';
import { SkinTypes } from '../../../../../enums/skin-types.enum';
import {
  FullImgCardModel,
  FullImgCardComponent,
} from '../../../components/full-img-card/full-img-card.component';
import { CaseTimelineComponent } from '../../../components/case-timeline/case-timeline.component';
import { ConsultationHistoryModel } from '../../../../core/models/consultation/consultation-history.model';
import { GaugeChartComponent } from '../../../components/gauge-chart/gauge-chart.component';
import { GenderUtils } from '../../../../utils/gender-utils';
import { ToastService } from '../../../../core/services/toast.service';
import { Subscription } from 'rxjs';

export interface PatientImageModel {
  id: string;
  src?: string;
  alt?: string;
  patientRecordId?: string;
  isSelected?: boolean;
  createdDate?: string;
  fileData?: any;
  fileName?: string;
}

@Component({
  selector: 'app-patient-detail',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    FullscreenOverlayComponent,
    TranslateModule,
    FullImgCardComponent,
    CaseTimelineComponent,
    GaugeChartComponent,
  ],
  templateUrl: './patient-detail.component.html',
  styleUrl: './patient-detail.component.scss',
  providers: [DatePipe],
})
export class PatientDetailComponent {
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('modal') modal!: ElementRef;
  @ViewChild('chatContainer') chatContainer!: ElementRef;
  @ViewChild('rightFirstTab') rightFirstTab!: ElementRef<HTMLAnchorElement>;
  caseStatus = CaseStatus;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private consultationsService: ConsultationsService,
    private patientsService: PatientsService,
    private chatService: ChatService,
    private currentUserService: CurrentUserService,
    private fullscreenService: FullscreenService,
    private signalRService: SignalRService,
    private translate: TranslateService,
    private languageService: LanguageService,
    private toastService: ToastService
  ) {
    this.createPatientImageConnection();
    const userLang = localStorage.getItem('selectedLanguage') || 'en';
    this.translate.use(userLang);
    this.createPatientConnection();
    this.closePatientDetail();
    this.createChatConnection();
    // this.handleNewCaseCreateConnection();
  }
  patientId: string = '';
  patientIdFromPatientDetail: string = '';
  patientRecordCaseId: string = '';
  consultationTimeline: any[] = [];
  patientImages: PatientImageModel[] = [];
  isOverlayLoading: boolean = false;
  consultationTimeLines: any = [];
  selectedTimeline: ConsultationHistoryModel;
  selectedImage: any = null;
  caseNo: number = 0;
  patientHeaderInformations: any = [];
  patientCaseDetails: any = [];
  showAllImages: boolean = false;
  consultationId: string = '';
  chatList: any = null;
  messageText: string = '';
  file: File | null = null;
  fileCount: any = null;
  currentUser: UserSessionModel | null = null;
  private tabChangeListener: any;
  private chatInterval: any;
  reportError: string = '';
  consultationReportError: string = '';
  statusClass: string;
  statusText: string;
  private imageInterval: any;
  isChatSending: boolean = false;
  caseIdFromPatientDetail: string = '';
  recordIdFromPatientDetail: string = '';
  selectedLang: string = localStorage.getItem('selectedLanguage') || 'en';

  aiImages: AiImagesModel = {
    gaugeImage: '',
    radarChartImage: '',
    lesionSpaceImage: '',
    cbirImage: '',
    blendedImage: '',
    spaceImage: '',
    saturationSpaceImage: '',
    cbir1Image: '',
    cbir2Image: '',
    cbir3Image: '',
    cbir4Image: '',
    cbir5Image: '',
    gaugeRate: '',
    cbir1Value: '',
    cbir2Value: '',
    cbir3Value: '',
    cbir4Value: '',
    cbir5Value: '',
    allImagesExist: false,
  };

  showImageGalleryAi: boolean = true;
  fullscreenImageAi: any = null;
  activeRightTab: '#aiReport';
  patientIdFromAppointmentList: string = '';
  appointmentIdFromAppointmentList: string = '';
  defaultUserImage: string | ArrayBuffer | null = null;
  currentUserAvatar: string | ArrayBuffer | null = null;
  otherUserAvatar: string | ArrayBuffer | null = null;
  otherUserName: string = '';
  isCaseActivated: boolean = false;

  async ngOnInit() {
    this.subscriptions.add(
      this.translate.onLangChange.subscribe(() => {
        if (
          this.patientHeaderInformations &&
          this.patientHeaderInformations.gender
        ) {
          this.patientHeaderInformations.gender = GenderUtils?.getGenderName(
            this.patientHeaderInformations.genderId
          );
        }
      })
    );

    await StatusUtils?.initializeTranslateService(this.translate);
    await GenderUtils?.initializeTranslateService(this.translate);
    this.patientId = this.route.snapshot.paramMap.get('id')!;
    this.currentUser = this.currentUserService.GetSession();
    this.patientsService.setPatientId(this.patientId);
    this.consultationTimeLineByPatientId(this.patientId);
    this.getChatList(this.consultationId);

    const currentRoutePath = this.route.snapshot.routeConfig?.path;

    // Come from consultation detail
    if (currentRoutePath.split('/')[0] === 'details') {
      this.route.params.subscribe((params) => {
        this.patientIdFromPatientDetail = params['id'];
        this.caseIdFromPatientDetail = params['caseId'];
        this.recordIdFromPatientDetail = params['recordId'];
      });
      this.getAiImages(this.caseIdFromPatientDetail);
    }

    // Come from appointment list
    if (currentRoutePath.split('/')[0] === 'appointment-detail') {
      this.route.params.subscribe((params) => {
        this.patientIdFromAppointmentList = params['id'];
        this.appointmentIdFromAppointmentList = params['appointmentId'];
      });
    }
  }

  protected async createPatientConnection() {
    const signalRBasePath = `${environment.apiLocations.patient}`.split(
      '/api/v1'
    )[0];
    const hubUrl = 'patient-hub';
    this.signalRService.connect(hubUrl, signalRBasePath);
    this.signalRService.on(hubUrl, 'receivePatientUpdated', signalRBasePath, (message) => {
      const parsedJson = JSON.parse(message);
      if (parsedJson?.PatientRecordCaseId === this.consultationId) {
        this.patientHeaderInformations.patientStatus = parsedJson.PatientStatus;
      }
    });
  }

  protected async closePatientDetail() {
    const signalRBasePath = `${environment.apiLocations.patient}`.split(
      '/api/v1'
    )[0];
    const hubUrl = 'patient-hub';
    this.signalRService.connect(hubUrl, signalRBasePath);
    this.signalRService.on(hubUrl, 'receiveConsultationClosed', signalRBasePath, (message) => {
      const parsedJson = JSON.parse(message);
      if (
        parsedJson?.PatientRecordId === this.patientCaseDetails?.patientRecordId
      ) {
        this.router.navigate(['/patient/list']);
      }
    });
  }

  protected createPatientImageConnection() {
    const signalRBasePath = `${environment.apiLocations.patient}`.split(
      '/api/v1'
    )[0];
    const hubUrl = 'patient-hub';
    this.signalRService.connect(hubUrl, signalRBasePath);
    this.signalRService.on(hubUrl, 'receiveImageUploaded', signalRBasePath, (message) => {
      const parsedJson = JSON.parse(message);
      if (parsedJson.PatientRecordCaseId === this.consultationId) {
        const image = {
          id: parsedJson.PatientRecordCaseImageId,
          src: `data:image/jpeg;base64,${parsedJson.FileData}`,
          createdDate: parsedJson.CreatedDate,
          fileData: parsedJson.FileData,
          fileName: parsedJson.FileName,
          isSelected: parsedJson.IsSelected,
        };
        this.patientImages = [image, ...this.patientImages];
        this.consultationTimeLineByPatientId(this.patientId);
      }
    });
  }

  protected async handleNewCaseCreateConnection() {
    const signalRBasePath = `${environment.apiLocations.patient}`.split(
      '/api/v1'
    )[0];
    const hubUrl = 'patient-hart-hub';
    this.signalRService.connect(hubUrl, signalRBasePath);
    this.signalRService.on(hubUrl, 'receivePatientRecordCaseCreated', signalRBasePath, (message) => {
      const parsedJson = JSON.parse(message);
      if (parsedJson) {
        this.consultationTimeLines = parsedJson;
      }
    });
  }

  protected async createChatConnection() {
    const signalRBasePath = `${environment.apiLocations.chat}`.split(
      '/api/v1'
    )[0];
    const hubUrl = 'chat-hub';
    this.signalRService.connect(hubUrl, signalRBasePath);
    this.signalRService.on(hubUrl, 'receiveChatAdded', signalRBasePath, (message) => {
      const parsedJson = JSON.parse(message);
      if (parsedJson.PatientRecordCaseId === this.consultationId) {
        if (parsedJson?.Message) {
          const newMessage = {
            chatId: parsedJson.ChatId,
            patientRecordCaseId: parsedJson.PatientRecordCaseId,
            createdUserId: parsedJson.CreatedUserId,
            createdUserName: parsedJson.CreatedUserName,
            message: parsedJson.Message,
            chatFiles: parsedJson.ChatFiles || [],
          };
          console.log("newMessage", newMessage)
          this.chatList = [...this.chatList, newMessage];
          setTimeout(() => {
            this.scrollToBottom();
          }, 500);
        }
      }
    });
  }

  ngAfterViewInit() {
    this.fullscreenService.initializeFullscreenButtons();
    this.tabChangeListener = this.handleTabChange.bind(this);
    document.querySelectorAll('[data-bs-toggle="tab"]').forEach((tab) => {
      tab.addEventListener('shown.bs.tab', this.tabChangeListener);
    });
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();

    if (this.chatInterval) {
      clearInterval(this.chatInterval);
    }
    if (this.imageInterval) {
      clearInterval(this.imageInterval);
    }
    document.querySelectorAll('[data-bs-toggle="tab"]').forEach((tab) => {
      tab.removeEventListener('shown.bs.tab', this.tabChangeListener);
    });
  }

  handleTabChange(event: Event) {
    const target = event.target as HTMLElement;
    const href = target.getAttribute('href');
    // if (href === '#aiReport') {
    //   this.getAiImages(this.consultationId);
    // }
    if (href === '#consultationReport') {
      this.getConsultationReport(this.consultationId);
    } else if (href === '#chatWithDermatolog') {
      this.getChatList(this.consultationId);
      setTimeout(() => {
        this.scrollToBottom();
      }, 500);
      this.markMessagesAsRead(this.consultationId);
    } else if (href === '#qrCode') {
      this.createPatientRecordWithQrCode(this.consultationId);
    }
  }

  qrCodeDetails: { url: string };
  createPatientRecordWithQrCode(caseId: string) {
    this.patientsService.getPatientRecordWithQrCode(caseId).subscribe({
      next: (res) => {
        const blob = new Blob([res], { type: 'image/png' });
        const url = URL.createObjectURL(blob);
        this.qrCodeDetails = { url: url };
      },
    });
  }

  async getAiImages(id: string) {
    const data = await this.consultationsService.getAiImages(
      id,
      () => { },
      (error: any) => {
        this.reportError = this.translate.instant('errorNoAIReport');
      }
    );
    
    // CBIR imajlarından en az biri varsa AI Report tab'ı göster
    const hasCbirImages = !!(
      data.cbir1Image ||
      data.cbir2Image ||
      data.cbir3Image ||
      data.cbir4Image ||
      data.cbir5Image
    );
    
    this.aiImages.allImagesExist = hasCbirImages;
    this.aiImages.gaugeImage = `data:image/jpeg;base64,${data.gaugeImage}`;
    this.aiImages.radarChartImage = `data:image/jpeg;base64,${data.radarChartImage}`;
    this.aiImages.lesionSpaceImage = `data:image/jpeg;base64,${data.lesionSpaceImage}`;
    this.aiImages.cbirImage = `data:image/jpeg;base64,${data.cbirImage}`;
    this.aiImages.blendedImage = `data:image/jpeg;base64,${data.blendedImage}`;
    this.aiImages.spaceImage = `data:image/jpeg;base64,${data.spaceImage}`;
    this.aiImages.saturationSpaceImage = `data:image/jpeg;base64,${data.saturationSpaceImage}`;
    this.aiImages.cbir1Image = `data:image/jpeg;base64,${data.cbir1Image}`;
    this.aiImages.cbir2Image = `data:image/jpeg;base64,${data.cbir2Image}`;
    this.aiImages.cbir3Image = `data:image/jpeg;base64,${data.cbir3Image}`;
    this.aiImages.cbir4Image = `data:image/jpeg;base64,${data.cbir4Image}`;
    this.aiImages.cbir5Image = `data:image/jpeg;base64,${data.cbir5Image}`;
    this.aiImages.cbir1Value = data.cbir1Value;
    this.aiImages.cbir2Value = data.cbir2Value;
    this.aiImages.cbir3Value = data.cbir3Value;
    this.aiImages.cbir4Value = data.cbir4Value;
    this.aiImages.cbir5Value = data.cbir5Value;
    this.aiImages.gaugeRate = data.gaugeRate;
  }

  showFullImgCard: FullImgCardModel | null = null;

  openFullImgCard(image: PatientImageModel) {
    this.showFullImgCard = {
      src: image.src,
    };
  }

  closeFullImgCard() {
    this.showFullImgCard = null;
  }

  closeModal() {
    /**todo
     * delete this
     */
  }

  consultationTimeLineByPatientId(id: string) {
    this.patientsService.getConsultationHistoryByPatientId(id).subscribe({
      next: (res) => {
        if (res?.length) {
          let consultationHistoryModel =
            res.find((record) => record.isActivated) || res[0];
          if (this.caseIdFromPatientDetail) {
            consultationHistoryModel =
              res.find(
                (item) =>
                  item.patientRecordCaseId === this.caseIdFromPatientDetail
              ) || res[0];
          }

          this.consultationId = consultationHistoryModel.patientRecordCaseId;

          let activatedRecords = res.filter((record) => record.isActivated);
          this.consultationTimeLines = activatedRecords;
          this.getPatientDetailImagesById(
            consultationHistoryModel.patientRecordCaseId
          );
          this.getPatientInformationsAndLocation(
            consultationHistoryModel.patientRecordCaseId
          );
          this.getPatientRecordCaseDetail(
            consultationHistoryModel.patientRecordCaseId
          );
          this.selectedTimeline = consultationHistoryModel;
          this.caseNo = consultationHistoryModel.patientRecordCaseNumber;
          this.isCaseActivated = consultationHistoryModel.isActivated;
        } else {
          this.getFirstConsultation(res);
        }
      },
    });
  }

  getFirstConsultation(res) {
    this.consultationId = res[0].patientRecordCaseId;
    this.consultationTimeLines = res;
    this.getPatientDetailImagesById(res[0].patientRecordCaseId);
    this.getPatientInformationsAndLocation(res[0].patientRecordCaseId);
    this.getPatientRecordCaseDetail(res[0].patientRecordCaseId);
    this.selectedTimeline = res[0];
    this.caseNo = res[0].patientRecordCaseNumber;
  }

  onChangeSelectedTimeline(selectedTimeline: any): void {
    this.closeFullImgCard();
    this.rightFirstTab?.nativeElement?.click();
    this.patientImages = [];
    this.selectedTimeline = selectedTimeline;

    // if (!selectedTimeline?.cases.length) {
    //   this.caseNo = selectedTimeline.patientRecordCaseNumber;
    // }else{
    // }
    const parent = this.consultationTimeLines.find((parentItem: any) =>
      parentItem.cases?.some(
        (caseItem: any) =>
          caseItem.patientRecordCaseId === selectedTimeline.patientRecordCaseId
      )
    );

    this.caseNo = parent
      ? parent.patientRecordCaseNumber
      : selectedTimeline.patientRecordCaseNumber;

    // this.caseNo = selectedTimeline.patientRecordCaseNumber;

    this.consultationId = selectedTimeline.patientRecordCaseId;
    this.getPatientInformationsAndLocation(
      selectedTimeline.patientRecordCaseId
    );
    this.getPatientRecordCaseDetail(selectedTimeline.patientRecordCaseId);
    this.getPatientDetailImagesById(this.consultationId);
    if (this.imageInterval) clearInterval(this.imageInterval);
    this.imageInterval = setInterval(() => {
      this.getPatientDetailImagesById(this.consultationId);
    }, 5000);
    // Activate Case Information
    const leftSideTabsContainer = document.querySelector('.container.card');
    if (leftSideTabsContainer) {
      const tabs = leftSideTabsContainer.querySelectorAll('.nav-link');
      tabs.forEach((tab) => {
        tab.classList.remove('active');
      });

      const caseInformationTab = leftSideTabsContainer.querySelector(
        'a[href="#caseInformation"]'
      ) as HTMLElement;
      if (caseInformationTab) {
        caseInformationTab.classList.add('active');

        const caseInformationContent = leftSideTabsContainer.querySelector(
          '#caseInformation'
        ) as HTMLElement;
        const allTabContents =
          leftSideTabsContainer.querySelectorAll('.tab-pane');

        allTabContents.forEach((content) => {
          content.classList.remove('active', 'show');
        });

        if (caseInformationContent) {
          caseInformationContent.classList.add('active', 'show');
        }
      }
    }
  }
  address: string = "";
  getPatientInformationsAndLocation(id: string) {
    this.consultationsService
      .consultationDetailByPatientRecordCaseId(id)
      .subscribe({
        next: (res) => {
          if (res) {
            this.patientHeaderInformations = res;
            this.address =
              (res?.address ? res?.address + ' ' : "")
              + ' ' +
              (res?.houseNumber ? res?.houseNumber + ' ' : "")
              + ' ' +
              (res?.place ? res?.place + ' ' : "")
              + ' ' +
              (res?.postCode ? res?.postCode : "");
            this.address = this.address.replace('  ', ' ').trim();
            if (!this.address || this.address === 'undefined' || this.address === 'null') {
              this.address = '';
            }
            this.statusClass = StatusUtils?.getCaseStatusClass(
              res?.patientStatus
            );
            this.statusText = StatusUtils?.getCaseStatusText(
              res?.patientStatus
            );
          }
        },
      });
  }

  getPatientDetailImagesById(id: string) {
    if (id) {
      this.consultationsService.patientRecordImagesByPatientId(id).subscribe({
        next: (res) => {
          if (res.length > 0) {
            this.patientImages = res.map((image: any, index: number) => ({
              src: `data:image/jpeg;base64,${image.fileData}`,
              id: `imageModal${index + 1}`,
              alt: `Lesion Close-up ${index + 1}`,
              patientRecordId: image.id,
              isSelected: image.isSelected,
            }));
          }
        },
      });
    }
  }

  getPatientRecordCaseDetail(id: string) {
    if (id) {
      this.patientsService.patientRecordCaseDetail(id).subscribe({
        next: (res) => {
          if (res) {
            this.patientCaseDetails = res;
          }
        },
      });
    }
  }

  // selectImage(event: MouseEvent, imag: any) {
  //   event.preventDefault();

  //   this.patientImages = this.patientImages.map((image: any) => ({
  //     ...image,
  //     isSelected: false,
  //   }));

  //   this.patientImages = this.patientImages.map((image: any) =>
  //     image.id === imag.id ? { ...image, isSelected: true } : image
  //   );

  //   this.selectedImage = imag;
  //   this.patientsService
  //     .updateSelectedPatientRecordCaseImage(this.selectedImage.patientRecordId)
  //     .subscribe({
  //       next: () => {},
  //       error: () => {},
  //     });
  // }

  toggleImageView() {
    this.showAllImages = !this.showAllImages;
  }

  parseLocation(location: string): { top: string; left: string } {
    const [left, top] = location.split(',').map((coord) => coord.trim());
    return {
      top: `${top}px`,
      left: `${left}px`,
    };
  }

  selectCase(timeLine: any, event: MouseEvent) {
    event.stopPropagation();
    this.router.navigate(['/patient/add-patient-case-card'], {
      queryParams: { id: timeLine.patientRecordCaseId },
    });
  }

  getAIReport(id: string) {
    this.consultationsService
      .patientRecordCaseReportsByPatientRecordCaseId(id)
      .subscribe({
        next: (res) => {
          if (res?.patientRapport === '') {
            this.reportError = this.translate.instant('errorNoAIReport');
          } else {
            this.reportError = '';
            this.displayPdf(res.patientRapport, 'ai');
          }
        },
        error: () => {
          this.reportError = this.translate.instant('errorNoAIReport');
        },
      });
  }

  getConsultationReport(id: string) {
    this.consultationsService.getReport(id).subscribe({
      next: (res) => {
        if (res?.patientRapport === '') {
          this.consultationReportError = this.translate.instant(
            'errorNoConsultationReportDesc'
          );
        } else {
          this.consultationReportError = '';
          this.displayPdf(res.patientRapport, 'consultation');
        }
      },
      error: () => {
        this.consultationReportError = this.translate.instant(
          'errorNoConsultationReportDesc'
        );
      },
    });
  }

  displayPdf(base64Pdf: string, type: string) {
    const byteCharacters = atob(base64Pdf);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);
    const iframe = document.createElement('iframe');
    iframe.src = blobUrl;
    iframe.width = '100%';
    iframe.height = '600px';
    iframe.style.border = 'none';

    let content: HTMLElement | null = null;
    if (type === 'ai') {
      content = document.getElementById('aiReport');
    } else if (type === 'consultation') {
      content = document.getElementById('consultationReport');
    }

    if (content) {
      content.innerHTML = '';
      content.appendChild(iframe);
      iframe.oncancel = () => {
        URL.revokeObjectURL(blobUrl);
      };
    }
  }

  closeConsultation() {
    this.isOverlayLoading = true;
    const form = {
      patientRecordCaseId: this.consultationId,
      patientStatus: 6,
    };
    this.patientsService
      .closePatientRecordCase(this.consultationId, form)
      .subscribe({
        next: () => {
          this.toastService.showToast(
            this.translate.instant('successCloseConsultationDesc'),
            'success'
          );
          setTimeout(() => {
            this.router.navigate(['/patient/list']);
          }, 2000);
        },

        complete: () => {
          setTimeout(() => {
            this.isOverlayLoading = false;
          }, 2000);
        },
      });
  }

  getStatusClass(status: number): string {
    return StatusUtils?.getCaseStatusClass(status);
  }

  getStatusText(status: number): string {
    return StatusUtils?.getCaseStatusText(status);
  }

  getChatList(id: string) {
    if (!id) return;
    this.scrollToBottom();
    this.chatService.chatList(id).subscribe({
      next: (res) => {
        if (res) {
          this.chatList = res;
          this.getUserAvatars();
          this.getOtherUserName();
        }
      },
    });
  }

  getUserAvatars() {
    const userIds = this.chatList?.map((item) => item.createdUserId);

    const formData = {
      userIds,
    };

    this.chatService.userAvatars(formData).subscribe({
      next: (res) => {
        this.currentUserAvatar = res?.find(
          (item) => item.userId === this.currentUser?.id
        )?.avatarImage
          ? `data:image/jpeg;base64,${res.find((item) => item.userId === this.currentUser?.id)
            ?.avatarImage
          }`
          : 'assets/media/profile/profile-picture.png';

        this.otherUserAvatar = res?.find(
          (item) => item.userId !== this.currentUser?.id
        )?.avatarImage
          ? `data:image/jpeg;base64,${res.find((item) => item.userId !== this.currentUser?.id)
            ?.avatarImage
          }`
          : 'assets/media/profile/profile-picture.png';
      },
    });
  }

  mappedChatFileNames(chatItem: any): string {
    return chatItem.chatFiles.map((file) => file.chatFileName).join(', ');
  }

  handleFileClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.fileInput.nativeElement.click();
  }

  handleFileUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.fileCount = input.files.length;
      this.file = input.files[0];
      input.value = '';
    }
  }

  downloadChatFile(path: string, fileName: string) {
    const base64Data = path.includes(',') ? path.split(',')[1] : path;

    const binaryString = window.atob(base64Data);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    a.href = url;
    a.download = fileName;
    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  sendChat(id: string): void {
    if (this.messageText.trim() === '' && this.file == null) return;

    this.isChatSending = true;
    const createChatModel: CreateChatModel = {
      patientRecordCaseId: id,
      patientName: this.patientHeaderInformations.name,
      patientSurname: this.patientHeaderInformations.lastName,
      patientRecordCaseNumber:
        this.patientHeaderInformations.patientRecordCaseNumber,
      createdUserName: this.currentUser?.name || '',
      message: this.messageText || '',
      expertUserName: this.patientHeaderInformations?.expertUserName || '',
      generalPractitionerUserName:
        this.patientHeaderInformations?.generalPractitionerUserName || '',
      file: this.file,
    };
    this.chatService.chat(createChatModel).subscribe({
      next: (res) => {
        if (res) {
          this.messageText = '';
          this.file = null;
          this.fileCount = null;
          this.getChatList(this.consultationId);
        }
      },
      complete: () => {
        this.isChatSending = false;
      },
    });
  }

  async takePictureAgain() {
    const json = {
      patientRecordCaseId: this.consultationId,
    };

    this.patientsService.photoAgain(json).subscribe({
      next: async () => {
        this.toastService.showToast(
          this.translate.instant('successTakeImageDesc'),
          'success'
        );
      },
    });
  }

  scrollToBottom(): void {
    const interval = setInterval(() => {
      if (this.chatContainer && this.chatContainer.nativeElement) {
        this.chatContainer.nativeElement.scrollTop =
          this.chatContainer.nativeElement.scrollHeight + 200;
        clearInterval(interval);
      }
    }, 500);
  }

  get isButtonActive(): boolean {
    return this.patientImages.some((image) => image.isSelected);
  }

  getSelectedImage(): any {
    this.selectedImage =
      this.patientImages.find((image) => image.isSelected) || null;
    return this.selectedImage;
  }

  skinTypeTextHeader(): any {
    if (this.patientCaseDetails.length == 0) return '';
    const skinTypeHeaderText = this.translate.instant('skinTypeHeader');
    switch (this.patientCaseDetails?.dermatologyCaseInformation?.skinType) {
      case SkinTypes.Type1:
        return `${skinTypeHeaderText} 1`;

      case SkinTypes.Type2:
        return `${skinTypeHeaderText} 2`;

      case SkinTypes.Type3:
        return `${skinTypeHeaderText} 3`;

      case SkinTypes.Type4:
        return `${skinTypeHeaderText} 4`;

      case SkinTypes.Type5:
        return `${skinTypeHeaderText} 5`;

      case SkinTypes.Type6:
        return `${skinTypeHeaderText} 6`;

      default:
        return '';
    }
  }

  generalAppearanceTextHeader(): any {
    let generalAppearanceText: string = ', ';

    if (
      this.patientCaseDetails?.dermatologyCaseInformation?.generalAppearance
        ?.freckles
    ) {
      generalAppearanceText += this.translate.instant('freckles') + ', ';
    }
    if (
      this.patientCaseDetails?.dermatologyCaseInformation?.generalAppearance
        ?.redHair
    ) {
      generalAppearanceText += this.translate.instant('redHair') + ', ';
    }
    if (
      this.patientCaseDetails?.dermatologyCaseInformation?.generalAppearance
        ?.lightColoredEyes
    ) {
      generalAppearanceText +=
        this.translate.instant('lightColoredEyes') + ', ';
    }
    if (generalAppearanceText.endsWith(', ')) {
      generalAppearanceText = generalAppearanceText.slice(0, -2);
    }
    return generalAppearanceText;
  }

  medicalHistoryAreaText(): any {
    let medicalHistoryText: string = '';

    this.patientCaseDetails?.dermatologyCaseInformation?.riskFactors?.forEach(
      (element) => {
        medicalHistoryText += element.name + '<br>';
      }
    );

    this.patientCaseDetails?.dermatologyCaseInformation?.dermatologicDiseases?.forEach(
      (element) => {
        medicalHistoryText += element.name + '<br>';
      }
    );

    this.patientCaseDetails?.dermatologyCaseInformation?.neoplasticDiseases?.forEach(
      (element) => {
        medicalHistoryText += element.name + '<br>';
      }
    );

    this.patientCaseDetails?.dermatologyCaseInformation?.diseaseCousingImmunosuppressions?.forEach(
      (element) => {
        medicalHistoryText += element.name + '<br>';
      }
    );

    this.patientCaseDetails?.dermatologyCaseInformation?.otherDiseases?.forEach(
      (element) => {
        medicalHistoryText += element.name + '<br>';
      }
    );

    return medicalHistoryText;
  }

  medicationsDiseasesAreaText(): any {
    let dermotologicDiseasesText: string = '';
    this.patientCaseDetails?.medications?.forEach((element) => {
      dermotologicDiseasesText += element.name + '<br>';
    });

    return dermotologicDiseasesText;
  }

  neoPlasticDiseasesAreaText(): any {
    let neoPlasticDiseasesText: string = '';

    this.patientCaseDetails?.dermatologyCaseInformation?.diseaseCousingImmunosuppressions?.forEach(
      (element) => {
        neoPlasticDiseasesText += element.name + '<br>';
      }
    );

    return neoPlasticDiseasesText;
  }

  lesionCharacteristicAreaText(): any {
    let lesionCharacteristicText: string = '';
    const lessionCharacteristic =
      this.patientCaseDetails?.dermatologyCaseInformation?.lesionCharacteristic;
    if (!lessionCharacteristic) return lesionCharacteristicText;
    const complaintsText =
      '<b>' + this.translate.instant('complaints') + ': </b>';
    const sinceText = '<b>' + this.translate.instant('since') + ': </b>';
    const changeText = '<b>' + this.translate.instant('change') + ': </b>';
    const complaintsArray: Array<string> = [];
    const sincesArray: Array<string> = [];
    const changesArray: Array<string> = [];
    /** complaints */
    if (lessionCharacteristic.itching) {
      complaintsArray.push(this.translate.instant('itching'));
    }
    if (lessionCharacteristic.pain) {
      complaintsArray.push(this.translate.instant('pain'));
    }
    if (lessionCharacteristic.bleeding) {
      complaintsArray.push(this.translate.instant('bleeding'));
    }
    if (lessionCharacteristic.ulceration) {
      complaintsArray.push(this.translate.instant('ulceration'));
    }
    /** since */
    if (lessionCharacteristic.hasCongenital) {
      sincesArray.push(this.translate.instant('congenital'));
    }
    if (lessionCharacteristic.customCongenitalValue != null) {
      const value = lessionCharacteristic.customCongenitalValue;
      if (value) {
        const valueNumber = parseInt(value.split(' ')[0]);
        let valueText = value.split(' ')[1];
        valueText =
          valueNumber > 1
            ? this.translate.instant('weeks_txt')
            : this.translate.instant('week_txt');
        const formattedCongenitalValue = valueNumber + ' ' + valueText;
        sincesArray.push(formattedCongenitalValue);
      }
    }

    /** change */
    if (lessionCharacteristic.hasSizeChange) {
      changesArray.push(this.translate.instant('size'));
    }
    if (lessionCharacteristic.hasGreaterThan6mmChange) {
      changesArray.push(this.translate.instant('greatherThan6mm'));
    }
    if (lessionCharacteristic.hasBorderChange) {
      changesArray.push(this.translate.instant('border'));
    }
    if (lessionCharacteristic.hasColorChange) {
      changesArray.push(this.translate.instant('color'));
    }
    /** final */
    if (complaintsArray?.length) {
      lesionCharacteristicText += complaintsText + complaintsArray.join(', ');
    }
    if (sincesArray?.length) {
      if (!!lesionCharacteristicText) lesionCharacteristicText += '<br>';
      lesionCharacteristicText += sinceText + sincesArray.join(', ');
    }
    if (changesArray?.length) {
      if (!!lesionCharacteristicText) lesionCharacteristicText += '<br>';
      lesionCharacteristicText += changeText + changesArray.join(', ');
    }
    return lesionCharacteristicText;
  }

  get medicationsItems() {
    return this.patientCaseDetails?.medications.map((item) => ' ' + item.name);
  }

  get complaintItems() {
    return this.patientCaseDetails?.complaints.map((item) => ' ' + item.name);
  }

  get symptomItems() {
    return this.patientCaseDetails?.otherSymptoms.map(
      (item) => ' ' + item.name
    );
  }

  get predispositionItems() {
    return this.patientCaseDetails?.geneticPredispositions.map(
      (item) => ' ' + item.name
    );
  }

  showAiImagesFullscreen(image: any) {
    this.showImageGalleryAi = false;
    this.fullscreenImageAi = image;
  }

  closeAiImagesFullscreen() {
    this.showImageGalleryAi = true;
    this.fullscreenImageAi = null;
  }

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = '/assets/media/not-found.jpeg';
  }

  getActionButtonConfig(isNoAppointment: boolean, type: string): any {
    if (type === 'newConsultation') {
      return {
        routerLink: isNoAppointment
          ? ['/patient/new-patient-case-card', this.patientId]
          : [
            '/patient/new-patient-case-card-appointment',
            this.patientId,
            this.appointmentIdFromAppointmentList,
          ],
        class: 'btn btn-primary btn-sm fw-bold me-md-2',
        label: 'newConsultation',
      };
    } else if (type === 'followUpConsultation') {
      return {
        routerLink: isNoAppointment
          ? [
            '/patient/add-patient-case-card',
            this.patientId,
            this.consultationId,
          ]
          : [
            '/patient/add-patient-case-card-appointment',
            this.patientId,
            this.consultationId,
            this.appointmentIdFromAppointmentList,
          ],
        class: 'btn btn-dark btn-sm fw-bold',
        label: 'followUpConsultation',
      };
    }
    return {};
  }

  getOtherUserName(): void {
    const isOtherUserChatExist = this.chatList?.some(
      (chat) => chat.createdUserId !== this.currentUser?.id
    );
    if (isOtherUserChatExist) {
      this.otherUserName = this.chatList?.find(
        (chat) => chat.createdUserId !== this.currentUser?.id
      )?.createdUserName;
    }
  }

  markMessagesAsRead(caseId: string) {
    this.chatService.markMessagesAsRead(caseId).subscribe({
      next: () => { },
    });
  }
}
